module.exports = __webpack_public_path__ + "img/horizontal_4_7_pp12_9006.0a2ffc6d.png";